import connectInfiniteHits from './connectInfiniteHits.js';
import withInsights from '../../lib/insights/client.js';

var connectInfiniteHitsWithInsights = withInsights(connectInfiniteHits);

export { connectInfiniteHitsWithInsights as default };
